import { useEffect, useState } from "react";
import { Modal, Form, Space, Typography, Button } from "antd";
import { MaskedInput } from "antd-mask-input";

import useCreate from "hooks/useCreate";
import useFormErrors from "hooks/useFormErrors";

import { useAuth } from "context/providers/auth";

const CreateUserPinModal = ({ is_open, handleClose }) => {
  const [is_loading, setLoading] = useState(false);
  const { updatePin } = useAuth();

  const [form] = Form.useForm();

  const { pristine, has_error, onFieldsChange } = useFormErrors();

  const handleOk = () => form.submit();

  useEffect(() => {
    form.resetFields();
    // eslint-disable-next-line
  }, [is_open]);

  const { is_saving, create: sendEmailWithPin } = useCreate({
    path: "/passwords/send_email_with_pin",
    success_message:
      "Wiadomość z kodem blokady została wysłana na adres e-mail",
  });

  return (
    <Modal
      style={{ top: 45 }}
      maskClosable={false}
      title="Zmień kod PIN blokady ekranu"
      open={is_open}
      onOk={handleOk}
      onCancel={handleClose}
      cancelText="Anuluj"
      okText="Zmień"
      okButtonProps={{
        disabled: pristine || has_error,
        loading: is_loading,
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFieldsChange={onFieldsChange}
        initialValues={{
          old_pin: "",
          pin: "",
        }}
        onFinish={async ({ old_pin, pin }) => {
          try {
            setLoading(true);
            await updatePin({ old_pin, pin });
            handleClose();
          } catch (error) {
          } finally {
            setLoading(false);
          }
        }}
      >
        <Form.Item
          label="Stary pin"
          name="old_pin"
          required
          hasFeedback
          rules={[
            () => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject(new Error("Pole wymagane"));
                }
                if (value.includes("_")) {
                  return Promise.reject(new Error("Niepoprawy pin"));
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <MaskedInput mask="0000" />
        </Form.Item>
        <Form.Item
          label="Nowy pin"
          name="pin"
          required
          hasFeedback
          rules={[
            () => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject(new Error("Pole wymagane"));
                }

                if (value.includes("_")) {
                  return Promise.reject(new Error("Niepoprawy pin"));
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <MaskedInput mask="0000" />
        </Form.Item>
      </Form>
      <Space direction="vertical">
        <Typography.Text>Nie pamiętasz kodu blokady?</Typography.Text>
        <Button
          loading={is_saving}
          htmlType="button"
          onClick={() => sendEmailWithPin()}
        >
          Wyślij na adres email
        </Button>
      </Space>
    </Modal>
  );
};

export default CreateUserPinModal;
